import { useEffect, useState } from "react";

/**
 * In-app palette switcher (admin-only).
 * Persists choice in localStorage so the user can compare:
 *   - "classic"  → Variant A (#007040 Clássica Sollute)
 *   - "briefing" → Variant B (#00B388 Nova Briefing)
 *
 * The theme is applied via `<html data-theme="...">` and the CSS uses
 * variable overrides scoped to that selector (see index.css).
 */
const STORAGE_KEY = "sollute_theme";

export function applyTheme(theme) {
  const html = document.documentElement;
  html.setAttribute("data-theme", theme);
  try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
}

export function getStoredTheme() {
  try { return localStorage.getItem(STORAGE_KEY) || "classic"; } catch { return "classic"; }
}

export default function ThemeSwitcher() {
  const [theme, setTheme] = useState(getStoredTheme());

  useEffect(() => { applyTheme(theme); }, [theme]);

  return (
    <div
      className="rounded-xl p-3 border border-slate-200"
      style={{ background: "#F8FAFC" }}
      data-testid="theme-switcher"
    >
      <div className="overline text-[9px] mb-2">Paleta visual</div>
      <div className="grid grid-cols-2 gap-1.5">
        <button
          onClick={() => setTheme("classic")}
          data-testid="theme-classic"
          className={`flex items-center gap-2 px-2 py-2 rounded-lg text-[11px] font-semibold border transition-all ${
            theme === "classic"
              ? "border-transparent text-white shadow-sm"
              : "bg-white border-slate-200 text-slate-700 hover:border-slate-300"
          }`}
          style={theme === "classic" ? { background: "linear-gradient(135deg, #007040 0%, #00D1A0 100%)" } : {}}
        >
          <span className="w-3 h-3 rounded-full" style={{ background: "#007040" }}></span>
          Clássica
        </button>
        <button
          onClick={() => setTheme("briefing")}
          data-testid="theme-briefing"
          className={`flex items-center gap-2 px-2 py-2 rounded-lg text-[11px] font-semibold border transition-all ${
            theme === "briefing"
              ? "border-transparent text-white shadow-sm"
              : "bg-white border-slate-200 text-slate-700 hover:border-slate-300"
          }`}
          style={theme === "briefing" ? { background: "linear-gradient(135deg, #00B388 0%, #00D1A0 100%)" } : {}}
        >
          <span className="w-3 h-3 rounded-full" style={{ background: "#00B388" }}></span>
          Briefing
        </button>
      </div>
    </div>
  );
}
